module.exports = __webpack_public_path__ + "img/eat.3bd93d2c.jpeg";